import type ApolloClient from 'apollo-client';
import gql from 'graphql-tag';

const GET_CUSTOM_CONTENT = gql`
	query CustomContent($id: ID!, $type: String!) {
		content(id: $id) {
			nodes {
				ari
				children(type: $type) {
					nodes {
						body {
							atlas_doc_format {
								value
							}
						}
						title
					}
				}
			}
		}
	}
`;

export type CustomContentResponse = {
	data: {
		content: {
			nodes: {
				ari: string;
				children: {
					nodes: {
						body: {
							atlas_doc_format: {
								value: string;
							};
						};
						title: string;
					}[];
				};
			}[];
		};
	};
};

export const getStaticMacroContent = async ({
	apolloClient,
	pageId,
	type,
}: {
	apolloClient: ApolloClient<object>;
	pageId: string;
	type: string;
}) => {
	const { data } = await apolloClient.query({
		query: GET_CUSTOM_CONTENT,
		variables: {
			id: pageId,
			type: type,
		},
		// Required to ensure apollo does not return cached data when switching between edit and view mode
		fetchPolicy: 'network-only',
	});

	return data.content?.nodes?.[0]?.children?.nodes || [];
};
